var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-jobs"},[_c('div',{staticClass:"tip"},[_vm._v(" "+_vm._s(_vm.i18n.Pra.Yours)),_c('b',[_vm._v(_vm._s(_vm.i18n.Pra.text111))]),_vm._v(_vm._s(_vm.i18n.Pra.text112)+" ")]),_c('Course',{attrs:{"id":_vm.id,"isPractice":_vm.isPractice,"typeInfo":_vm.typeInfo,"detail":_vm.detail,"type":1}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }